$(document).ready(function () {


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * teleport links
    // *
    // * @set outer parent element class: js-href-teleport-wrapper
    // * @set link (<a> tag) element class: js-href-teleport-link
    // * @set element to add the link to class: js-href-teleport
    // *
    // * This adds a link tag (<a>) to other elements within a wrapper
    // * links comes from a link. Example: add a link to h2, image etc. inside a teaser
    // *
    $(".js-href-teleport").each(function () {
        var $link = $(this).parents(".js-href-teleport-wrapper").find(".js-href-teleport-link"),
            href = $link.attr("href"),
            target = $link.attr("target") ? $link.attr("target") : '_self';

        if (href) {
            $(this).wrapInner('<a href="' + href + '" target="' + target + '"></a>');
        }
    });



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * parent clickable elements (excludes links inside)
    // *
    // * @set outer parent element class: js-click-item-parent
    // * @set link (<a> tag) element class: js-click-item-link
    // *
    // * This makes the whole element clickable and still
    // * makes other links inside clickable with their target
    // *
    $(".js-click-item-parent").delegate('a', 'click', function (e) {
        var target = $(this).attr("target"),
            url = $(this).attr("href");

        if (target == "_blank") {
            window.open(url);
        } else {
            window.location = url;
        }
        return false;
    }).click(function () {
        var target = $(this).find("a.js-click-item-link").attr("target"),
            url = $(this).find("a.js-click-item-link").attr("href");

        if (target == "_blank") {
            window.open(url);
        } else {
            window.location = url;
        }
        return false;
    });




    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * animateIn
    // *
    // *
    var offset = 80; // Distance from Browserbottom & -top where the animation should start

    function fadeInElements() {
        var viewPortStart = $(window).scrollTop(),
            viewPortEnd = viewPortStart + $(window).height();


        $(".animateIn:visible").each(function () {
            var elementTop = $(this).offset().top,
                elementBottom = $(this).offset().top + $(this).outerHeight();

            if ((elementTop + offset) <= viewPortEnd && (elementBottom - offset) >= viewPortStart) {
                var delay = $(this).data("animation-delay");
                $(this).css("transition-delay", delay + "s").addClass("animateIn--active");
            } else {
                // $(this).removeClass("animateIn--active");
            }
        });
        $(".js-animate-svg:visible").each(function () {
            var elementTop = $(this).offset().top,
                elementBottom = $(this).offset().top + $(this).outerHeight();

            if ((elementTop + offset) <= viewPortEnd && (elementBottom - offset) >= viewPortStart) {
                $(this).addClass("active");
            } else {
                // $(this).removeClass("active");
            }
        });
    }

    $(window).scroll(function () {
        fadeInElements();
    });

    fadeInElements();


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * add target blank to external links
    // *
    // *
    $('a:not([data-targetblank=ignore])').each(function () {
        if (location.hostname === this.hostname || !this.hostname.length) {
            // ... do nothing?
        } else {
            $(this).attr('target', '_blank');
        }
    });


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * navButton
    // *
    // *
    $(".js-navbutton").click(function () {
        $(this).toggleClass("active");
        $(".js-aside").toggleClass("navOpen");
        $(".js-navmobile").toggleClass("active");
        $(this).blur();
    });

    $(document).on('keydown', function (event) {
        if (event.key === 'Escape') {
            $(".js-navbutton").removeClass("active");
            $(".js-aside").removeClass("navOpen");
            $(".js-navmobile").removeClass("active");

        }
    });


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * heroSlider
    // *
    // *
    var $heroSlider = $(".js-hero-slider");

    if ($heroSlider.length) {
        $heroSlider.each(function () {
            $(this).find(".js-hero-slider-track").slick({
                fade: true,
                infinite: true,
                arrows: true,
                autoplay: true,
                autoplaySpeed: 2500,
                speed: 1000,
                waitForAnimate: true,
                dots: false,
                pauseOnHover: false,
                prevArrow: $(this).find(".js-hero-slider-prev"),
                nextArrow: $(this).find(".js-hero-slider-next"),
            });
        });
    }

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * gallerySlider
    // *
    // *
    var centerPaddingGallery = $(window).width() < 1920 ? '31vw' : '640px';
    var $gallerySlider = $(".js-gallery-slider");
    if ($gallerySlider.length) {
        $gallerySlider.each(function () {
            $(this).find(".js-gallery-slider-track").slick({
                fade: false,
                infinite: true,
                arrows: true,
                autoplay: true,
                autoplaySpeed: 5000,
                speed: 1000,
                adaptiveHeight: true,
                centerMode: true,
                centerPadding: centerPaddingGallery,
                slidesToShow: 1,
                waitForAnimate: true,
                dots: false,
                pauseOnHover: false,
                prevArrow: $(this).find(".js-gallery-slider-prev"),
                nextArrow: $(this).find(".js-gallery-slider-next"),
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            centerPadding: '20.5vw',
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            centerPadding: '13.5vw',
                        }
                    },
                ]
            });
        });
    }

    function getCenterPadding() {
        return $(window).width() < 1920 ? '31vw' : '640px';
    }

    $(window).resize(function () {
        $gallerySlider.each(function () {
            $(this).find(".js-gallery-slider-track").slick('slickSetOption', 'centerPadding', getCenterPadding(), true);
        });
    });



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * teamSlider
    // *
    // *
    var $teamSlider = $(".js-team-slider");

    if ($teamSlider.length) {
        $teamSlider.each(function () {
            $(this).find(".js-team-slider-track").slick({
                fade: false,
                infinite: true,
                arrows: true,
                autoplay: true,
                autoplaySpeed: 4000,
                speed: 1000,
                waitForAnimate: true,
                dots: false,
                pauseOnHover: false,
                prevArrow: $(this).find(".js-team-slider-prev"),
                nextArrow: $(this).find(".js-team-slider-next"),
                mobileFirst: true,
                responsive: [
                    {
                        breakpoint: 500,
                        settings: "unslick"
                    }
                ]
            });
        });
    }


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * accordion
    // *
    // *
    $(".js-accordion-button").click(function () {
        // Toggle the aria-expanded attribute for the current accordion item
        const $content = $(this).siblings(".js-accordion-content");
        const isExpanded = $content.attr("aria-expanded") === "true";
        $content.attr("aria-expanded", !isExpanded);

        // Close other accordion items
        $(this).parents(".js-accordion-wrapper")
            .find(".js-accordion-content")
            .not($content)
            .attr("aria-expanded", "false");

        setTimeout(() => {
            $(this)[0].scrollIntoView({ behavior: 'smooth' });
        }, 400);
    });

    function openAccordionFromHash() {
        let hash = window.location.hash.split('#')[1];
        if (hash && $("#" + hash).hasClass("js-accordion-button") && $("#" + hash).siblings(".js-accordion-content").attr("aria-expanded") !== "true") {
            $("#" + hash).click();
        }
    }

    // open acoordion on load
    openAccordionFromHash();

    // open accordion from same page
    $(window).on('hashchange', function () {
        openAccordionFromHash();
    });

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * scrolltop
    // *
    // *
    $(".js-scrolltop button").click(function () {
        $(window).scrollTop(0);
    })

    // * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
    // * dialog window
    // *
    // *
    var $dialog = $(".js-dialog"),
        dialogState = sessionStorage.getItem('dialogState');

    $(".js-close-dialog").click(function () {
        $dialog.addClass("close");
        setTimeout(() => {
            sessionStorage.setItem('dialogState', true);
            $(this).parents(".js-dialog").get(0).close();
            $("body").removeClass("freeze");
        }, 400);

    });

    // backdrop click
    $(".js-dialog").click(function (e) {
        if (e.target === e.currentTarget) {
            $dialog.addClass("close");
            setTimeout(() => {
                sessionStorage.setItem('dialogState', true);
                $(this).get(0).close();
                $("body").removeClass("freeze");
            }, 400);

        }
    });

    if (!dialogState && $dialog.length > 0) {
        $dialog.get(0).showModal();
        $("body").addClass("freeze");
    }

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * read more
    // *
    // *
    $(".js-read-more-button").click(function () {
        $(this).parents(".js-read-more-wrapper").find(".js-read-more-target").toggleClass("expand");
        $(this).toggleClass("active")
        const label = $(this).find('.js-read-more-label');
        const moreText = label.data('more');
        const lessText = label.data('less');
        const currentText = label.text();

        // Toggle the text
        if (currentText === moreText) {
            label.text(lessText);
        } else {
            label.text(moreText);
        }

        $(this).parents(".js-read-more-wrapper").get(0).scrollIntoView();
        $(this).blur();
    })

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * video prelaod none autoplay fix
    // *    Note: The preload attribute is ignored if autoplay is present.
    // *
    if ($(".js-video").length > 0) {
        $(".js-video").get(0).play();
    }

    if (window.matchMedia('(pointer: coarse)').matches || window.matchMedia('(hover: none)').matches) {
        $('.js-aside-button').click(function (e) {
            if (!$(this).hasClass("clicked")) {
                e.preventDefault();
                $(this).parents(".js-aside").find(".js-aside-button").removeClass("clicked");
                $(this).addClass("clicked");
            }
            // On second click, the class is already present, so link follows normally
        });
    }

});

const asideElements = $('.js-aside-button');
const backgroundBlackElements = $('.backgroundDarkBlue');

function isElementOnTop(element1, element2) {
    const rect1 = element1.getBoundingClientRect();
    const rect2 = element2.getBoundingClientRect();

    const overlap = !(
        rect1.right < rect2.left ||
        rect1.left > rect2.right ||
        rect1.bottom < rect2.top ||
        rect1.top > rect2.bottom
    );

    if (overlap) {
        const zIndex1 = $(element1).css('z-index');
        const zIndex2 = $(element2).css('z-index');

        if (zIndex1 !== 'auto' && zIndex2 !== 'auto') {
            return parseInt(zIndex1, 10) > parseInt(zIndex2, 10);
        }
    }

    return false;


}




// * * * * * * * * * * * * * * * * * * * * * * * * *
// * sticky Header
// *
// *
$(window).on("load scroll", function () {
    if ($(window).scrollTop() >= 40) {
        $(".js-header").addClass("sticky");
        $(".js-scrolltop").addClass("active");
    } else {
        $(".js-header").removeClass("sticky");
        $(".js-scrolltop").removeClass("active");
    }

    if (backgroundBlackElements.length > 0) {
        asideElements.each(function () {
            let isOnTop = false;
            const asideElement = $(this);

            backgroundBlackElements.each(function () {
                if (isElementOnTop(asideElement[0], this)) {
                    isOnTop = true;
                    return false; // Break the loop if one element is on top
                }
            });

            asideElement.toggleClass('brighten', isOnTop);
        });
    }
});

